import PropertyForm from "@/components/PropertyForm";
export default function EditPropertyPage() { return <PropertyForm mode="edit" />; }
